<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      title="新建要货计划"
      width="1300px"
      top="4vh">
    <!-- 选择采购订单明细 -->
    <div style="margin-bottom: 10px; text-align: left;">
      <el-button type="primary" icon="el-icon-search" @click="openDetailSelect">
        选择采购订单明细
      </el-button>
      <span style="margin-left: 10px; color: #909399;">
        点击按钮在弹窗中搜索并多选采购订单明细，重复的采购订单行会自动跳过
      </span>
    </div>

    <!-- 已选列表 -->
    <el-table
        :data="selectedList"
        border
        stripe
        size="mini"
        max-height="400">
      <el-table-column type="index" label="序号" width="55" align="center"/>
      <el-table-column prop="purchaseOrderNo" label="采购订单号" min-width="120" show-overflow-tooltip/>
      <el-table-column prop="poDetailRowNo" label="行号" width="70" align="center"/>
      <el-table-column prop="materialNo" label="物料号" min-width="120" show-overflow-tooltip/>
      <el-table-column prop="materialName" label="物料描述" min-width="180" show-overflow-tooltip/>
      <el-table-column label="采购订单数量" width="110" align="center">
        <template slot-scope="scope">{{scope.row.purchaseQuantity}}</template>
      </el-table-column>
      <el-table-column label="剩余可要货数量" width="120" align="center">
        <template slot-scope="scope">{{scope.row.leftQty !== null && scope.row.leftQty !== undefined ? scope.row.leftQty : scope.row.purchaseQuantity}}</template>
      </el-table-column>
      <el-table-column label="本次要货数量" width="140" align="center">
        <template slot-scope="scope">
          <el-input-number
              v-model="scope.row.quantity"
              :min="0"
              :max="scope.row.leftQty"
              :controls="false"
              :precision="0"
              style="width: 100%"/>
        </template>
      </el-table-column>
      <el-table-column label="需求到货日期" width="170" align="center">
        <template slot-scope="scope">
          <el-date-picker
              v-model="scope.row.requireDeliveryDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="请选择日期"
              style="width: 100%"/>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="80" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="danger" size="mini" @click="removeRow(scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <span slot="footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" :loading="submitLoading" :disabled="!selectedList.length" @click="submitHandle">
        保 存（{{selectedList.length}} 条）
      </el-button>
    </span>
    <purchase-order-detail-select ref="detailSelect" @select="addSelectedRows"/>
  </el-dialog>
</template>

<script>
  import PurchaseOrderDetailSelect from "./PurchaseOrderDetailSelect.vue";

  export default {
    name: "PurchasePlanManualAdd",
    components: {PurchaseOrderDetailSelect},
    data() {
      return {
        dialogVisible: false,
        submitLoading: false,
        selectedList: [],
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.selectedList = [];
      },
      // 打开选择采购订单明细弹窗
      openDetailSelect() {
        this.$refs.detailSelect.open();
      },
      // 接收选择弹窗返回的多行，加入列表（按采购订单号+行号去重）
      addSelectedRows(rows) {
        if (!rows || !rows.length) {
          return;
        }
        let added = 0;
        let skipped = 0;
        rows.forEach((row) => {
          const key = `${row.evaluate}_${row.rowNum}`;
          const exists = this.selectedList.some(
            (item) => `${item.purchaseOrderNo}_${item.poDetailRowNo}` === key,
          );
          if (exists) {
            skipped++;
            return;
          }
          this.selectedList.push({
            purchaseOrderNo: row.evaluate || "",
            poDetailRowNo: row.rowNum,
            materialNo: row.partNo || "",
            materialName: row.partNameSpec || "",
            purchaseQuantity: row.qty,
            leftQty: row.leftQty != null ? row.leftQty : row.qty,
            quantity: row.leftQty != null ? row.leftQty : row.qty,
            requireDeliveryDate: (row.requireDeliveryDate || "").substring(0, 10),
          });
          added++;
        });
        this.$message.success(`成功添加 ${added} 条` + (skipped ? `，跳过重复 ${skipped} 条` : ""));
      },
      removeRow(index) {
        this.selectedList.splice(index, 1);
      },
      submitHandle() {
        if (!this.selectedList.length) {
          return this.$message.warning("请先添加要货明细");
        }
        // 前端校验：必填 + 数量
        for (let i = 0; i < this.selectedList.length; i++) {
          const item = this.selectedList[i];
          if (!item.purchaseOrderNo || !item.poDetailRowNo || !item.materialNo) {
            return this.$message.error(`第 ${i + 1} 条数据缺少采购订单号/行号/物料号`);
          }
          if (item.quantity == null || item.quantity <= 0) {
            return this.$message.error(`第 ${i + 1} 条【${item.materialNo}】本次要货数量必须大于0`);
          }
          if (!item.requireDeliveryDate) {
            return this.$message.error(`第 ${i + 1} 条【${item.materialNo}】请选择需求到货日期`);
          }
          if (item.quantity > (item.leftQty != null ? item.leftQty : 0)) {
            return this.$message.error(
              `第 ${i + 1} 条【${item.materialNo}】本次要货数量超过剩余可要货数量(${item.leftQty})`,
            );
          }
        }
        // 重复校验
        const keys = new Set();
        for (let i = 0; i < this.selectedList.length; i++) {
          const item = this.selectedList[i];
          const key = `${item.purchaseOrderNo}_${item.poDetailRowNo}`;
          if (keys.has(key)) {
            return this.$message.error(
              `采购订单【${item.purchaseOrderNo}】行号【${item.poDetailRowNo}】在列表中重复，请删除重复项`,
            );
          }
          keys.add(key);
        }
        // 组装批量入参（与导入模板 PurchasePlanImportVO 字段保持一致）
        const payload = this.selectedList.map((item) => ({
          status: "",
          purchaseOrderNo: item.purchaseOrderNo,
          poDetailRowNo: String(item.poDetailRowNo),
          materialNo: item.materialNo,
          materialName: item.materialName,
          purchaseQuantity: item.purchaseQuantity,
          quantity: item.quantity,
          requireDeliveryDate: item.requireDeliveryDate,
        }));
        this.submitLoading = true;
        this.$http.post("basic", "purchasePlans/manualCreateBatch", payload).then((resp) => {
          this.submitLoading = false;
          if (resp.success) {
            this.dialogVisible = false;
            this.$emit("save-success");
            this.$message.success("保存成功");
          } else {
            this.$message.error(resp.msg || "保存失败");
          }
        }).catch(() => {
          this.submitLoading = false;
        });
      },
    },
  };
</script>
